// @flow

import React from 'react';
import { generateDimensions } from '../column/helpers';
import ACFComponent from '../acfComponent';
import { ACFColumn } from '../column';
import type { ACFComponentColumn, ACFRowTemplate, ACFCut } from '../../types';
import type { BreakpointData } from '../row/types';
import DimensionContext from '../../context/dimensionContext';

type ColumnProps = {|
  column: ACFComponentColumn | boolean,
  responsiveData: BreakpointData,
  rowTemplate: ACFRowTemplate,
  cut: ACFCut,
  index: number,
  slideshow?: boolean, // eslint-disable-line react/require-default-props
|};

type Props = ColumnProps;

const ComponentColumn = ({
  column,
  ...otherProps
}: Props) => {
  if (typeof column === 'boolean') {
    return null;
  }
  return (
    <DimensionContext.Provider value={generateDimensions(column.responsive)}>
      <ACFColumn column={column} {...otherProps}>
        {column.components && column.components.map((component, key) => component && (
          <ACFComponent
            key={key} // eslint-disable-line
            component={component}
            noBox={column.is_boxed}
          />
        ))}
      </ACFColumn>
    </DimensionContext.Provider>
  );
};

export default ComponentColumn;
